<template>
  <!-- -->
  <div class="fhl-home">
    <div class="top-count">
      <board-data-statistic :data-list="erpStatistic" >
        <template v-slot:name="{data}">{{data.statisticName}}</template>
        <template v-slot:count="{data}">{{changeDataCount(data.statisticCount)}}</template>
        <template v-slot:desc="{data}">
          <span v-if="data.statisticType === 'shopCar'">共{{data.statisticCount2}}个客户</span>
          <span v-else>总计金额{{changeDataAmount(data.statisticMoney)}}</span>
        </template>
      </board-data-statistic>
    </div>
    <div class="order-month">
      <div class="rank">
        <div class="card">
          <employee-collection :default-list="['00150002', '00150003']"/>
        </div>
        <div class="card">
          <board-e-chart-bar-graph font-color="#999" grid-color="#eee" bar-width="30px" :data-list="echartDataList" :x-names="echartXNames" :name-list="echartNameList" :x-axis-label-length="10"/>
        </div>
      </div>
      <div class="right">
        <div class="group-info card">
          <board-data-count-icon :data-list="baseDataInfo">
            <template v-slot:count="{data}">
              <span v-if="data.statisticType === 'aiBusiness'">{{data.statisticCount}}<span style="font-size: var(--yq-font-size-small);color: var(--yq-font-color-desc)">账号数</span></span>
              <span v-else-if="data.statisticType === 'customer_constract'">{{data.statisticCount}}</span>
            </template>
            <template v-slot:desc="{data}">
              <span v-if="data.statisticType === 'aiBusiness'">
                已管理客户群{{data.statisticCount2}}<br/>
                已开启关键字{{data.statisticCount3}}</span>
              <span v-else-if="data.statisticType === 'customer_constract'">
                已关联小程序{{data.statisticCount2}}<br/>
                开通AI回复功能{{data.statisticCount3}}</span>
            </template>
          </board-data-count-icon>
        </div>
        <div class="product-rank card">
          <board-simple-overflow :data-list="erpOrderList">
            <template v-slot="{data}">
              <div class="erp-order-item">
                <div class="btype">{{data.btypeName}}</div>
                <div class="time">{{data.billDate?data.billDate.substring(0, 10):''}}</div>
                <div class="status">
                  <span v-if="data.dzstate === '0'">待发货</span>
                  <span v-if="data.dzstate === '1'">待配送</span>
                  <span v-if="data.dzstate === '2'">待签收</span>
                  <span v-if="data.dzstate === '3'">已完成</span>
                  <span v-if="data.dzstate === '4'">已退货</span>
                </div>
              </div>
            </template>
          </board-simple-overflow>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import BoardEChartBarGraph from "@/components/h5/board/BoardEChartBarGraph.vue";
import BoardSimpleRank3 from "@/components/h5/board/BoardSimpleRank3.vue";
import EmployeeCollection from "@/components/h5/board/CEmployeeCollection.vue";
import BoardSimpleOverflow from "@/components/h5/board/BoardSimpleOverflow.vue";
import BoardDataStatistic from "@/components/h5/board/BoardDataStatistic.vue";
import BoardDataCountIcon from "@/components/h5/board/BoardDataCountIcon.vue";
import numberUtil from "@/util/numberUtil";
import aiHomeDataApi from "@/api/dz-ai/aiHomeDataApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "FHL",
  components: {
    EmployeeCollection, BoardSimpleRank3, BoardSimpleOverflow, BoardEChartBarGraph, BoardDataStatistic, BoardDataCountIcon
  },
  data() {
    return {
      erpStatistic: [],
      baseDataInfo: [],
      erpOrderList: [],
      echartXNames: [],
      echartDataList: [],
      echartNameList: [],
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      // 订单统计
      aiHomeDataApi.queryOrderStatistic().then(list => this.erpStatistic = list);
      // 基础信息统计
      aiHomeDataApi.queryBaseInfoStatistic().then(list => this.baseDataInfo = list);
      // 最近一周的订单金额
      aiHomeDataApi.queryOrderAmountStatistic().then(list => {
        let xName = [];
        let dataList = [];
        for (let i = 0; i < list.length; i++) {
          xName.push(list[i].statisticName.substring(0, 10));
          dataList.push(this.changeDataAmount(list[i].statisticMoney));
        }
        this.echartXNames = xName;
        this.echartDataList = [dataList];
        this.echartNameList = ['订单金额'];
      });
      aiHomeDataApi.queryCurrentOrder().then(list => this.erpOrderList = list);
    },
    // 转成科学计数法
    changeDataCount(c) {
      return numberUtil.scientificNotation(c);
    },
    changeDataAmount(c) {
      return numberUtil.scientificNotationMoney(c);
    }
  }
};
</script>

<style lang="scss" scoped>
.fhl-home{
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-top: 20px;
  .card{
    background: #FFF;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px;
  }
  .order-month{
    height: 100px;
    flex: 1;
    display: flex;
    .rank{
      width: 100px;
      flex: 1;
      display: flex;
      flex-direction: column;
      .card:nth-child(1){
        height: 200px;
        margin-bottom: 20px;
      }
      .card:nth-child(2){
        flex: 1;
      }
    }
    .right{
      width: 400px;
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      .group-info{
        //height: 300px;
        margin-bottom: 20px;
      }
      .product-rank{
        height: 100px;
        flex: 1;
      }
    }
  }
}
.erp-order-item{
  display: flex;
  background: var(--yq-background-color);
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 10px;
  font-size: var(--yq-font-size-base);
  >*{
    white-space: nowrap;
  }
  .btype{
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>